
import CtrlCamposPage from './pages/CtrlCamposPage'

const routes = [
    {
        path: 'ctrl-campos',
        name: 'ctrl-campos',
        component: CtrlCamposPage 
    }
];

export default routes;